import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=0618df9c&scoped=true"
import script from "./UploadVideo.vue?vue&type=script&lang=js"
export * from "./UploadVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=0618df9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0618df9c",
  null
  
)

export default component.exports